import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from '#src/shared/error';

import type { PaginatedContextData, PaginatedData } from '#src/app/shared/contexts/asyncData';

import { LocalRecentPetitions } from './api.graphql';
import type { LocalRecentPetitionsQuery, LocalRecentPetitionsQueryVariables } from './api.graphql';
import type { LocalRecentPetitionsItem } from './types';

type LocalRecentPetitionsApiData = PaginatedData<
	LocalRecentPetitionsItem,
	{
		totalCount: number;
		totalCountLocalized: string;
	}
>;

export type LocalRecentPetitionsData = PaginatedContextData<LocalRecentPetitionsApiData>;

async function getData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
	queryParams: {
		listTagsFilter: string | undefined;
	},
	cursor?: string,
): Promise<LocalRecentPetitionsApiData> {
	const { data } = await fetch<LocalRecentPetitionsQuery, LocalRecentPetitionsQueryVariables>({
		query: LocalRecentPetitions,
		variables: { slug, cursor: cursor ?? null, tagIds: queryParams.listTagsFilter?.split(',') || null },
		rejectOnError: true,
	});

	if (!data.localPageLocation) throw new NotFoundError();

	return {
		items: data.localPageLocation.recentPetitionsConnection.edges,
		cursor: data.localPageLocation.recentPetitionsConnection.pageInfo.endCursor,
		hasNextPage: data.localPageLocation.recentPetitionsConnection.pageInfo.hasNextPage,
		totalCount: data.localPageLocation.recentPetitionsConnection.totalCount,
		totalCountLocalized: data.localPageLocation.recentPetitionsConnection.totalCountLocalized,
	};
}

export async function getFirstPageData(
	utilityContext: UtilityContext,
	slug: string,
	queryParams: { listTagsFilter: string | undefined },
) {
	return getData(utilityContext, slug, queryParams);
}

export async function getNextPageData(
	utilityContext: UtilityContext,
	cursor: string,
	slug: string,
	queryParams: { listTagsFilter: string | undefined },
) {
	return getData(utilityContext, slug, queryParams, cursor);
}
